<template>
  <LoadingScreen id="loading-screen" />
  <Navbar />
  <div class="page-content">
    <!-- <h1 class="header-large">Love Pets? We do too!</h1>
    <p class="home-message">Join our growing community now!</p>
    <router-link class="router-link" to="/login?signup=true">
      <Button class="call-to-action-home" text="Sign Up" />
    </router-link>
    <Paw />
    <h2 class="moto">Meet, Walk, Care!</h2> -->
    <div class="info-sections">
      <!-- <Paw /> -->

      <!-- <div class="info-section" @click="goToPage('/')"> -->
      <!-- <a class="info-section" href="https://folafinder.dating4pets.com">
        <Link class="link-btn" text="Fola Alert" icon="exclamation-triangle" />
        <p class="section-text">
          A useful tool to help you
          <span class="bold-text">make a safely daily walk</span> by
          <span class="underlined-text">reporting</span> and
          <span class="underlined-text">spotting</span> the location of folas
          (poisoned baits) near you.
        </p>
      </a> -->
      <a class="info-section" href="https://gracious-haibt-450346.netlify.app/">
        <Link class="link-btn" text="Fola Alert" icon="biohazard" />
        <p class="section-text">
          A useful tool to help you
          <span class="bold-text">make a safely daily walk</span> by
          <span class="underlined-text">reporting</span> and
          <span class="underlined-text">spotting</span> the location of folas
          (poisoned baits) near you.
        </p>
      </a>
      <!-- </div> -->
    </div>
    <div class="info-sections">
      <!-- <Paw /> -->

      <div class="info-section" @click="goToPage('/under_construction')">
        <Link class="link-btn" text="Pet Routes" icon="route" />
        <p class="section-text">
          Find <span class="bold-text">routes that are safe</span> for you and
          your pet to cross and have your daily walk with ease of mind!
        </p>
      </div>
    </div>

    <div class="info-sections">
      <!-- <Paw /> -->

      <div class="info-section" @click="goToPage('/under_construction')">
        <Link class="link-btn" text="Pet Alert" icon="exclamation-triangle" />
        <p class="section-text">
          Is <span class="underlined-text">your</span> pet
          <span class="bold-text">lost</span>? Did you
          <span class="underlined-text">find</span> a
          <span class="bold-text">lost</span> pet? Then this is the place.
        </p>
      </div>
    </div>
    <!-- <div class="info-sections">
      <Paw />
      <div class="info-section" @click="goToPage('/login?signup=true')">
        <Link class="link-btn" text="Fola Alert" />
        <p class="section-text">
          A useful tool to help you
          <span class="bold-text">make a safely daily walk</span> by
          <span class="underlined-text">reporting</span> and
          <span class="underlined-text">spotting</span> the location of folas
          (poisoned baits) near you.
        </p>
      </div>
    </div>
    <Socials /> -->
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
// import Paw from "@/components/stylistics/Paw.vue";
// import Socials from "@/components/Socials.vue";
import Link from "@/components/Link.vue";
import LoadingScreen from "@/components/LoadingScreen.vue";

import privacy_policy_json from "/public/privacy_policy.json";

export default {
  name: "Alert",
  components: {
    Navbar,
    Link,
    LoadingScreen,
  },
  mounted() {
    let title = "Alert - Dating4Pets";
    document.title = title;
    setTimeout(() => {
      let loadingScreen = document.querySelector("#loading-screen");
      loadingScreen.classList.add("fade-out");
    }, 1000);
  },
  methods: {
    goToPage(route) {
      let self = this;
      self.$router.push(route);
    },
  },
  data() {
    return {
      privacy_policy: privacy_policy_json,
    };
  },
};
</script>

<style scoped>
.page-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow: visible;
}

@media screen and (max-width: 50rem) {
  .page-content {
    flex-direction: column !important;
    gap: calc(var(--gap) + 1em);
  }
}

.bold-text {
  font-weight: bolder;
}

.info-section {
  min-width: 15em;
  width: 30%;
  max-width: 30em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--light-clr);
  box-shadow: var(--light-box-shadow);
}

.info-sections .info-section,
.info-sections .info-section {
  padding: 1em;
  border-radius: var(--border-radius);
  transition: var(--transition);
  cursor: pointer;
}

.info-sections {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.info-sections .info-section {
  margin-block-start: 2em;
}

.info-sections .info-section,
.info-sections .info-section .link-btn {
  cursor: pointer;
}

.link-btn {
  font-size: 1.2em;
}

.info-sections .info-section:hover,
.info-sections .info-section:focus {
  background: var(--faint-bg);
}

.info-section {
  margin-block-start: 5em;
  width: 80%;
}

.info-section .section-header {
  margin-block-start: 1em;
  /* width: 80%; */
}
/* 
.info-section {
  min-width: 15em;
  width: 50%;
  max-width: 60em;
} */
</style>
